import moment from 'moment';
export const setProductFormData = (productData, productSectionData, productId) => {
    productData['sectionList'] = productSectionData;
    productData['enabled'] = true;
    let temp_id = 'js_' + productData.name + '_' + moment().unix();
    let id = temp_id.replace(/\s/g, '');
    if (productId) {
        productData['id'] = productId;
    } else {
        productData['id'] = id;
    }
    return productData
}

export const checkDulpicateProduct = (productFormData, productData) => {
    let flag = false;
    productData.forEach((item, index, element) => {
        if (item.enabled === true &&
            item.name.toLowerCase() === productFormData.name.toLowerCase()) {
            flag = true
        }
    })
    return flag
}
export const validateProductData = (productData, creditData, editStatus) => {
    let flag = false;
    if (!creditData && editStatus === false) {
        return false
    }
    for (let i = 0; i < productData.length; i++) {
        if (productData[i].enabled === true) {
            return true
        }
    }
    return flag
}